// extracted by mini-css-extract-plugin
export default {"Section":"Headings_Section__EZtVB","title":"Headings_title__ktRrJ","subtitle":"Headings_subtitle__th8kt"};